var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.statistics_status === 'success')?_c('charts',{attrs:{"chart_data":this.statistics}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }